define(function(require,exports){"use strict";exports.WidgetModel=function(lpWidget){this.data=[],this.widget=lpWidget}});


// WEBPACK FOOTER //
// ./src/widget-hdfc-loan-against-property-emi-calculator/scripts/models.js